var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col-12 col-sm-8 col-lg-6 m-auto" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h1", [_vm._v(_vm._s(_vm._f("trans")("st_public.login_as")))])
          ]),
          _c("div", { staticClass: "card-body" }, [
            _vm.error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")(
                        "st_public.invalid_login_token_cannot_login"
                      )
                    )
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ]),
    _vm.loading ? _c("div", { staticClass: "loading-page" }) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e57375a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e57375a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/loginas/_login_token.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8e57375a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/loginas/_login_token.vue
// module chunks = 40